<template>
  <section role="tree" :class="[baseCss, rounded ? ['rounded', 'overflow-hidden'] : null, `shadow-${elevation}`, disabled ? ['disabled', 'pointer-events-none'] : null]" :is="tag">
    <ul :class="['barebone-list']" role="tree">
      <slot />
    </ul>
  </section>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'Collapsible',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('collapsible', ['block', 'w-full'])
    }
  },
  props: {
    tag: {
      type: String,
      default: 'section'
    },
    expandCollapseIcon: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean
    },
    divider: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: true
    },
    paddingOff: {
      type: Boolean
    },
    bgColor: {
      type: String,
      default: 'white'
    },
    color: {
      type: String,
      default: 'black'
    },
    maxHeight: {
      type: String
    },
    iconCollapse: {
      type: String,
      default: 'chevron-up'
    },
    iconExpand: {
      type: String,
      default: 'chevron-down'
    },
    bgColorExpanded: {
      type: String,
      default: 'gray'
    },
    bgColorLightnessExpanded: {
      type: Number,
      default: 200
    },
    colorExpanded: {
      type: String,
      default: 'black'
    },
    colorLightnessExpanded: {
      type: Number,
      default: null
    },
    rounded: {
      type: Boolean
    },
    truncateLabels: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style>
.bcq-collapsible .bcq-collapsible-item .bcq-collapsible-item-icon
{
  width: 32px;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/collapsible/collapsible.vue